import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";

import "./plugins/vuelidate";
import "./plugins/moment";
import "./plugins/axios";
import "./plugins/vue-notification";

/** DISABLED PRODUCTION TIP */
Vue.config.productionTip = false;

/** CREATE VUE APP */
new Vue({
    vuetify,
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
